import {
  Box,
  Heading,
  Button,
  Image,
  Flex,
  Text,
  Input,
  FormLabel,
  Textarea,
  Container,
  Grid,
  useToast,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./Contact.css";
import AOS from "aos";
import { Link } from "@chakra-ui/react";
import { HiOutlineMail } from "react-icons/hi";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import emailjs from "@emailjs/browser";
import { themeContext } from "../Context";

export const Contact = () => {
  const form = useRef();
  const toast = useToast();
  const [formData, setFormData] = useState({
    to_name: "",
    from_name: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!formData.to_name || !formData.from_name || !formData.message) {
      toast({
        title: "All fields are required",
        isClosable: true,
        status: "warning",
        duration: 4000,
        position: "top",
      });

      return;
    } else {
      emailjs
        .sendForm(
          "service_6ap8hzo",
          "template_7y5iwn8",
          form.current,
          "TayiWCX0aSjbzhXex"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );

      toast({
        title: "Your message has been sent.",
        // description: "We've created your account for you.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    }

    setFormData({
      to_name: "",
      from_name: "",
      message: "",
    });
  };
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <>
      <Box
        // bg={"#2F2F2F"}
        // bg={'#162030'}
        id="contact"
        // bg={"black"}
        color={"white"}
        className="about section"
        textAlign={"center"}
        //  h="100vh"
        pb="20px"
         paddingTop={{ base: "60px", md: "80px" }}
      >
        <Heading
          className="contact-heading"
          mt="40px"
          display={"inline-block"}
          padding="10px"
          color={"#FCA61F"}
          fontFamily={"initial"}
          mb="45px"
          as={"h1"}
          size={"2xl"}
        >
          Contact
        </Heading>
        <Flex
          flexDirection={{
            base: "column",
            sm: "column",
            md: "column",
            lg: "row",
            xl: "row",
            "2xl": "row",
          }}
          margin={"auto"}
          w={"90%"}
          p={"0% 5%"}
          justifyContent={"space-around"}
        >



          <Box
           fontFamily="cursive"
          display={"flex"} flexDirection={"column"} alignSelf={"center"}>
            <Link
              className="links"
              display={"flex"}
              id="contact-linkedin"
              href="mailto:yhemant203@gmail.com"
              isExternal
            >
              <HiOutlineMail
                style={{ marginLeft: "20px" }}
                className="contact-icon"
              />
              <Text id="contact-email" marginTop={"35px"} style={{color: darkMode? 'white': '#788097'}}>
                yhemant203@gmail.com
              </Text>
            </Link>

            <Link
              className="links"
              display={"flex"}
              id="contact-linkedin"
              href="tel:+919911695440"
              isExternal
            >
              <FiPhoneCall
                style={{ marginLeft: "20px" }}
                className="contact-icon"
              />
              <Text id="contact-phone" marginTop={"35px"} style={{color: darkMode? 'white': '#788097'}}>
                +91 9911695440
              </Text>
            </Link>

            <Link
              className="links"
              display={"flex"}
              id="contact-linkedin"
              href="https://www.linkedin.com/in/hemant-yadav-868296278/"
              isExternal
            >
              <FaLinkedin
                style={{ marginLeft: "20px" }}
                className="contact-icon"
              />
              <Text marginTop={"35px"} style={{color: darkMode? 'white': '#788097'}}>Linkeden</Text>
            </Link>


            
            <Link
              className="links"
              display={"flex"}
              id="contact-github"
              href="https://github.com/Hemant142/"
              isExternal
            >
              <FaGithub
                style={{ marginLeft: "20px" }}
                className="contact-icon"
              />
              <Text marginTop={"35px"} style={{color: darkMode? 'white': '#788097'}}>Github</Text>
            </Link>


            
          </Box>



          <Box
           fontFamily="cursive"
            w={{
              base: "80%",
              sm: "80%",
              md: "80%",
              lg: "60%",
              xl: "60%",
              "2xl": "50%",
            }}
            margin={"auto"}
          >
            <Box margin={"20px auto"}>
              <form ref={form} onSubmit={sendEmail}>
                <Box mb="10px" style={{color: darkMode? 'white': '#788097'}}>
                  <FormLabel >Name</FormLabel>
                  <Input
                    type="text"
                    name="to_name"
                    value={formData.to_name}
                    onChange={(e) => handleChange(e)}
                    placeholder="Name"
                  />
                </Box>
                <Box mb="10px" style={{color: darkMode? 'white': '#788097'}}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    name="from_name"
                    value={formData.from_name}
                    onChange={(e) => handleChange(e)}
                    placeholder="Email"
                  />
                </Box>
                <Box style={{color: darkMode? 'white': '#788097'}}>
                  <FormLabel>Message</FormLabel>
                  <Textarea
                    name="message"
                    value={formData.message}
                    onChange={(e) => handleChange(e)}
                    placeholder="Message"
                  ></Textarea>
                </Box>
                <Box mt="30px" style={{color: darkMode? 'white': '#788097'}}>
                  <Link>
                    {/* <Button
                      type="submit"
                      w="100%"
                      mr="20px"
                      backgroundColor={"#FCA61F"}
                      fontFaminly="cursive"
                      color="white"
                      p="10px 40px"
                      borderRadius={"5px"}
                      _hover={{
                        color: "#FCA61F",
                        backgroundColor: "white",
                        boxShadow: "white 0px 0px 10px",
                      }}
                      onClick={sendEmail}
                    > */}

                    <Button
                    mt="10px"
                    id="resume-button-2"
                    background="#FCA61F"
                    color={"white"}
                    onClick={sendEmail}
                    className="home-resume btn-box home-icon button i-button "
                  >
                      Send
                      </Button>
                    {/* </Button> */}
                  </Link>
                </Box>
              </form>
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};
